import React, { useState, useEffect } from "react";
import baseURL from "../../../Url/NodeBaseURL";
import axios from "axios";

const AccountBalanceTable = () => {
  const [accountData, setAccountData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {

      try {
        const response = await fetch(`${baseURL}/get-unique-repair-details`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log("Data from AccountBalanceTable:", data);

        // Process the data to combine duplicates and sum balances
        const processedData = processAccountData(data);
        setAccountData(processedData);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };
    cleanupEstimates();
    fetchData();
  }, []);

  const cleanupEstimates = async () => {
    try {
      const cleanupResponse = await axios.get(`${baseURL}/cleanup-old-estimates`);
      console.log("Old estimates cleanup completed:", cleanupResponse.data);
    } catch (cleanupError) {
      console.error("Error cleaning up old estimates:", cleanupError);
    }
  };
  const processAccountData = (data) => {
    const accountMap = new Map();

    data.forEach((item) => {
      const originalName = item.account_name || "";
      const normalizedName = originalName.toLowerCase(); // Case-insensitive key

      // Calculate balance amount using your logic
      const totalAmount = Number(item.net_bill_amount) || 0;

      if (accountMap.has(normalizedName)) {
        const existing = accountMap.get(normalizedName);
        accountMap.set(normalizedName, {
          ...existing,
          totalAmount: existing.totalAmount + totalAmount,
        });
      } else {
        accountMap.set(normalizedName, {
          accountName: originalName.toUpperCase(),
          totalAmount,
        });
      }
    });

    // Sort by net_bill_amount in descending order (highest at top)
    const sortedData = Array.from(accountMap.values()).sort(
      (a, b) => b.totalAmount - a.totalAmount
    );
    return sortedData.slice(0, 20);
  };

  if (loading) {
    return (
      <div style={{ padding: "10px", textAlign: "center" }}>Loading...</div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "10px", color: "red", textAlign: "center" }}>
        Error: {error}
      </div>
    );
  }

  return (
    <div
      style={{
        height: "240px",
        overflowY: "auto",
        width: "100%",
        marginTop: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "13px",
        }}
      >
        <thead>
          <tr
            style={{
              backgroundColor: "#f5f5f5",
              position: "sticky",
              top: 0,
            }}
          >
            <th
              style={{
                padding: "6px 10px",
                textAlign: "left",
                borderBottom: "1px solid #ddd",
                fontWeight: "600",
                color: "#b77318",
              }}
            >
              Account Name
            </th>
            <th
              style={{
                padding: "6px 10px",
                textAlign: "right",
                borderBottom: "1px solid #ddd",
                fontWeight: "600",
                color: "#b77318",
              }}
            >
              Total Spent
            </th>
          </tr>
        </thead>
        <tbody>
          {accountData.map((account, index) => (
            <tr
              key={index}
              style={{
                borderBottom: "1px solid #eee",
                ":hover": { backgroundColor: "#f9f9f9" },
              }}
            >
              <td
                style={{
                  padding: "6px 10px",
                  textAlign: "left",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "120px",
                }}
              >
                {account.accountName}
              </td>
              <td
                style={{
                  padding: "6px 10px",
                  textAlign: "right",
                  color: "#388e3c",
                  fontWeight: "500",
                }}
              >
                {
                  new Intl.NumberFormat("en-IN", {
                    style: "currency",
                    currency: "INR",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                    .format(account.totalAmount)
                    .replace(/^[^\d]+/, "") // Removes ₹ symbol
                }
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AccountBalanceTable;
